var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.item.type == 'link')?_c('div',[_c('a',{staticClass:"pb-link",attrs:{"contenteditable":_vm.contenteditable,"href":_vm.link}},[_vm._v("\n    "+_vm._s(_vm.item.content)+"\n  ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }